<template>
    <div class="global-tooltip">
        <div class='tooltip__position-anchor'>
            <button ref="anchor" class="tooltip__button" :class="isOpenClass" @click="openTooltip"></button>
            <div class="tooltip" v-if="showTooltip" :style="tooltipPosition">
                <global-button class="tooltip__button--close" icon="close" theme="secondary" @click="showTooltip = false" />
                <template v-if="htmlContent !== '' && htmlContent">
                    <div class="tooltip__content" v-html="htmlContent" />
                    <slot name="default" />
                </template>
                <template v-else>
                    <div class='tooltip__content'>
                        <slot name="content" />
                        <slot name="default" />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalButton from "@global/global-elements/global-button/global-button";
import {detectBreakpoint, gutters} from "@utilities/sal-breakpoint/sal-breakpoint";

export default {
    name: "global-tooltip",
    components: {GlobalButton},
    props: {
        htmlContent: '',
        uniqueIdentifier: {
            default: null,
        }
    },
    computed: {
        isOpenClass() {
            return this.showTooltip ? "tooltip--open": "tooltip--close"
        }
    },
    data() {
        return {
            showTooltip: false,
            tooltipPosition: '',
            uid: null
        }
    },
    methods: {
        openTooltip() {
            this.showTooltip = !this.showTooltip;
            this.updatePosition();
            window.dispatchEvent(new CustomEvent('tooltip-open', { detail: { uid: this.uid } }))
        },
        closeTooltip(e) {
            if(!e.detail) {
                return;
            }

            if (e.detail.uid) {
                if (e.detail.uid !== this.uid) {
                    this.showTooltip = false;
                }

                return
            }


            if (e.detail.target && !e.detail.target.closest('.global-tooltip')) {
                this.showTooltip = false;
            }
        },
        calculatePosition() {
            const tooltipWidth = 430;
            const anchorPosition = this.$refs.anchor.getBoundingClientRect();
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            const calcLeft = (anchorPosition.x + (anchorPosition.width / 2)) - (tooltipWidth / 2);
            const calcRight = (anchorPosition.x + (anchorPosition.width / 2)) + (tooltipWidth / 2);

            let left = '';
            let right = '';
            let bottom = 'bottom: ' + (gutters[detectBreakpoint()] * 2 + 10) + 'px;';

            if (calcLeft >= 0 && calcRight <= windowWidth) {
                left = 'left: ' + ((tooltipWidth / 2 - anchorPosition.width / 2) * -1) + 'px;';
            }

            if (calcLeft >= 0 && calcRight > windowWidth) {
                left = '';
                right = 'right: 0px;'
            }

            if (calcLeft < 0 && tooltipWidth <= windowWidth) {
                left = 'left: 0px;';
            }

            if (['xs', 'sm'].indexOf(detectBreakpoint()) !== -1) {
                left = 'left: ' + (anchorPosition.x * -1 + gutters[detectBreakpoint()] + (windowWidth - tooltipWidth) / 2) + "px;";
                right = '';
            }

            return left + right + bottom
        },
        updatePosition: function () {
            this.tooltipPosition = this.calculatePosition();
        }
    },
    created() {
        window.addEventListener('resize', this.updatePosition);
        window.addEventListener('tooltip-open', this.closeTooltip);
    },
    destroyed() {
        window.removeEventListener('resize', this.updatePosition);
    },
    mounted() {
        this.tooltipPosition = this.calculatePosition();
        this.uid = this.uniqueIdentifier !== null ? this.uniqueIdentifier: Math.floor(Math.random() * 100000)
    },
}
</script>

<style scoped>

</style>
